export default __webpack_public_path__ + "static/media/amanda-cerny.3076342f.png";